import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Button } from '../../../styled-components/';
import MosMessageLogTable from './MosMessageLogTable';
import ncsAppInfo from './mosTemplate/ncsAppInfo.xml';

const debug = process.env.NODE_ENV === 'development';

const MOS_TEMPLATE = {
  PING: 'PING',
  NCSAPPINFO: 'NCSAPPINFO'
};

const MESSAGE_TYPE = {
  LOG: 'log',
  IN: 'in',
  OUT: 'out'
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const MessageTemplateContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 0.5rem;
  > button {
    margin-right: 0.5rem;
  }
`;

const ControlContainer = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
`;

const PluginContainer = styled.div`
  width: 75%;
  height: 100%;
`;

const Plugin = styled.iframe`
  flex: 1;
  width: 100%;
  height: 100%;
`;

const MosTextArea = styled.textarea`
  height: 30%;
  margin-bottom: 0.5rem;
`;

const TableContainer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  flex: 1;
  border: 1px solid grey;
  width: 100%;
  overflow: auto;
`;

const LogControlContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;

const CheckboxContainer = styled.div`
  margin-right: 0.5rem;
`;

class ContainerTest extends PureComponent {
  constructor() {
    super();

    this.state = {
      mosValue: '',
      logs: [],
      tail: true,
      initialized: false
    };
  }

  componentDidMount() {
    if (this.plugin) {
      window.addEventListener('message', this.logLuciResponse);
    }
  }

  componentDidUpdate() {
    if (this.tableContainer && this.state.tail) {
      this.tableContainer.scrollTop = this.tableContainer.scrollHeight;
    }
  }

  componentWillUnmount() {
    if (this.plugin) {
      window.removeEventListener('message', this.logLuciResponse);
    }
  }

  setTemplate = mosTemplate => {
    let mosValue = '';

    switch (mosTemplate) {
      case MOS_TEMPLATE.PING:
        mosValue = '<mos><ping /></mos>';
        break;
      case MOS_TEMPLATE.NCSAPPINFO:
        mosValue = ncsAppInfo;
        break;
      default:
        break;
    }
    this.setState({ mosValue });
  };

  pluginLoaded = () => {
    this.writeLog('LUCI Loaded.', MESSAGE_TYPE.LOG);
    this.setState({ initialized: true });
  };

  handleTextAreaChange = e => {
    this.setState({ mosValue: e.target.value });
  };

  handleTailClicked = e => {
    this.setState({ tail: e.target.checked });
  };

  sendToLuci = () => {
    if (this.plugin) {
      this.plugin.contentWindow.postMessage(this.state.mosValue, window.location.origin);
      this.writeLog(this.state.mosValue, MESSAGE_TYPE.OUT);
    }
  };

  logLuciResponse = e => {
    // Internally, luci will be receiving a lot of messages, just get plaintext ones from the plugin
    if ((e.data && typeof e.data === 'string') || e.data instanceof String) {
      this.writeLog(e.data, MESSAGE_TYPE.IN);
    }
  };

  writeLog = (content, type) => {
    this.setState(state => {
      const logs = [
        ...state.logs,
        {
          timestamp: Date.now(),
          content,
          type
        }
      ];

      return {
        logs
      };
    });
  };

  clearLog = () => {
    this.setState({ logs: [] });
  };

  render() {
    return (
      <Container>
        <ControlContainer>
          <h2>Container Test Page</h2>
          <span>Mos message:</span>
          <MosTextArea value={this.state.mosValue} onChange={this.handleTextAreaChange} />
          <span>Message Templates:</span>
          <MessageTemplateContainer>
            <Button onClick={() => this.setTemplate(MOS_TEMPLATE.PING)}>Ping</Button>
            <Button onClick={() => this.setTemplate(MOS_TEMPLATE.NCSAPPINFO)}>NcsAppInfo</Button>
          </MessageTemplateContainer>
          <Button disabled={!this.state.initialized} onClick={this.sendToLuci}>
            Send To LUCI
          </Button>
          <TableContainer ref={r => (this.tableContainer = r)}>
            <MosMessageLogTable logs={this.state.logs} />
          </TableContainer>
          <LogControlContainer>
            <CheckboxContainer>
              <label htmlFor="tailCheckbox">
                <input
                  id="tailCheckbox"
                  type="checkbox"
                  defaultChecked={this.state.tail}
                  onChange={this.handleTailClicked}
                />
                Tail
              </label>
            </CheckboxContainer>
            <Button onClick={this.clearLog}>Clear Log</Button>
          </LogControlContainer>
        </ControlContainer>
        <PluginContainer>
          <Plugin
            ref={r => (this.plugin = r)}
            onLoad={this.pluginLoaded}
            src={`${window.location.origin}${debug ? '' : '/luci'}?origin=${
              window.location.origin
            }`}
          />
        </PluginContainer>
      </Container>
    );
  }
}

export default ContainerTest;



// WEBPACK FOOTER //
// ./app/components/Test/ContainerTest/index.js